import * as React from 'react';
import { useFormikContext } from 'formik';

import type {
  EventProceduresAPIType,
  EventProcedureStepAPIType,
} from 'security-app/hooks/api/eventProceduresAPI.types';

import EventProcedureStepForm from '../EventProcedureStepForm';

type Props = {
  onClose: () => void;
};

function NewStepModalFormik({ onClose }: Props) {
  const {
    values: { steps },
    setFieldValue,
    setFieldTouched,
  } = useFormikContext<EventProceduresAPIType<Array<EventProcedureStepAPIType>>>();

  const handleSaveStep = React.useCallback(
    (newStep: EventProcedureStepAPIType) => {
      setFieldValue('steps', [...steps, newStep]);
      setFieldTouched('steps', true);
      onClose();
    },
    [setFieldTouched, setFieldValue, onClose, steps],
  );

  return <EventProcedureStepForm onClose={onClose} onSave={handleSaveStep} />;
}

export default NewStepModalFormik;
